// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","fa-stack":"Footer_fa-stack__nmH2d"};